import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { CacheService } from '../../services/cache/cache.service';
import { Recipe, RecipesResult } from '../interfaces';

@Injectable({
  providedIn: 'root'
})
export class RecipesDataService {

  private uri: string = `${environment.apiUrl}recipes`;
  private cacheKey: string = 'recipes.cache';

  constructor(
    private http: HttpClient,
    private cache: CacheService,
  ) {

  }

  getRecipe(id: number): Observable<Recipe|any> {
    return this.http.get(this.uri + `/${id}`);
  }

  getRecipes(parameters: {[param: string]: string | string[]}): Observable<RecipesResult|any> {
    return this.http.get(this.uri, {params: parameters});
  }

  addRecipe(data: Recipe): Observable<Recipe|any> {
    this.clearCache();
    const cleanData = Object.assign({}, data);
    delete cleanData.id;
    return this.http.post(this.uri, cleanData);
  }

  addRecipes(data: Recipe[]): Observable<Recipe[]|any> {
    this.clearCache();
    return this.http.post(this.uri + `/bulk`, data);
  }

  updateRecipe(data: Recipe): Observable<Recipe|any> {
    this.clearCache();
    const cleanData = Object.assign({}, data);
    delete cleanData.id;
    return this.http.put(this.uri + `/${data.id}`, cleanData);
  }

  updateRecipes(data: Recipe[]): Observable<Recipe[]|any> {
    this.clearCache();
    return this.http.put(this.uri + `/bulk`, data);
  }

  patchRecipe(data: Recipe): Observable<Recipe|any> {
    this.clearCache();
    const cleanData = Object.assign({}, data);
    delete cleanData.id;
    return this.http.patch(this.uri + `/${data.id}`, cleanData);
  }

  patchRecipes(data: Recipe[]): Observable<Recipe[]|any> {
    this.clearCache();
    return this.http.patch(this.uri + `/bulk`, data);
  }

  deleteRecipe(data: Recipe): Observable<null|any> {
    this.clearCache();
    return this.http.delete(this.uri + `/${data.id}`);
  }

  deleteRecipes(data: Recipe[]): Observable<null|any> {
    this.clearCache();
    const params: {ids: string} = {ids: ''};
    const ids: string[] = [];
    data.forEach((recipe) => {
      ids.push(recipe.id + '');
    });
    params.ids = ids.join(',');
    return this.http.delete(this.uri + `/bulk`, {params: params});
  }

  clearCache(): void {
    this.cache.remove(this.cacheKey);
  }

}
